import { gql } from "apollo-boost";
// updateShop  name router
export const CREATE_STOCK_OPTION = gql `
  mutation CreateStockOption($dataStockOption: StockOptionInput, $dataStockOptionItems: [StockOptionItemInput]) {
    createStockOption(dataStockOption: $dataStockOption, dataStockOptionItems: $dataStockOptionItems)
  }
`;

export const CREATE_POST = gql`
  mutation CreatePost($data: PostInput!) {
    createPost(data: $data) {
        id
    }
}
`;

export const UPDATE_POST = gql`
  mutation UpdatePost($data: PostInput!,$where: PostWhereInputOne!) {
    updatePost(where: $where, data:$data) {
        id
    }
}
`;

export const UPDATE_STOCK = gql`
  mutation UpdateStock($data: StockInput!, $where: StockWhereInputOne!) {
    updateStock(data: $data, where: $where) {
        id
    }
}
`;


export const CREATE_POST_STOCK = gql`
  mutation CreatePostStock($data: PostStockInput!) {
    createPostStock(data: $data) {
        id
    }
}
`;

export const CREATE_MANY_POST_STOCK = gql`
mutation CreateManyPostStock($data: [PostStockInput]!) {
  createManyPostStock(data: $data) {
    message
  }
}
`;

export const UPDATE_POST_STOCK = gql`
  mutation UpdatePostStock($data: PostStockInput!,$where: PostStockWhereInputOne!) {
    updatePostStock(where: $where, data:$data) {
        id
    }
}
`;

export const UPDATE_MANY_POST_STOCK = gql`
  mutation UpdateManyPostStock($data: [PostStockInput]!, $where: PostStockWhereInputOne!) {
    updateManyPostStock(data: $data, where: $where) {
      message
    }
  }
`;

export const DELETE_POST_STOCK = gql`
  mutation DeletePostStock($where: PostStockWhereInputOne!) {
    deletePostStock(where: $where) {
        id
    }
}
`;

export const UPDATE_STOCK_OPTION = gql `
  mutation UpdateStockOption($data: StockOptionInput!, $where: StockOptionWhere) {
    updateStockOption(data: $data, where: $where)
  }
`;

export const UPDATE_MANY_STOCK_OPTION_ITEM = gql `
  mutation UpdateManyStockOptionItems($data: [StockOptionItemInput]!, $where: StockOptionWhere) {
    updateManyStockOptionItems(data: $data, where: $where)
  }
`;